import API from "../api/axios"; // tera axios.jsx

export const getAgents = (params) => {
   return API.get("/agents", { params });
};

export const addAgent = (data) => {
   return API.post("/agents", data);
};

export const updateAgent = (id, data) => {
   return API.put(`/agents/${id}`, data);
};

export const deleteAgent = (id) => {
   return API.delete(`/agents/${id}`);
};